import { Component } from '@angular/core';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { TooltipService } from '../Util/Tooltip/tooltip.service';
import { DownloadSampleService } from '../Model/DownloadSample/download-sample.service';
import { CustomDateParserFormatter } from '../Util/DateFormat/date-format.service';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { CommonService } from '../Model/Common/common.service';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SessionService } from '../Util/Session/session.service';
import { ExpenseService } from '../Model/Expense/expense.service';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
  selector: 'app-expense-report',
  standalone: true,
  imports: [LoaderComponent, CommonModule, FormsModule, NgSelectModule, NgbDatepickerModule],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './expense-report.component.html',
  styleUrl: './expense-report.component.scss'
})
export class ExpenseReportComponent {

  isDisabled: boolean = false;
  ExpenseData: any[] = [];

  Filter = {
    ESS_ExpenseReportRequestId: null,
    ESS_TripMasterId: null,
    SelectType: 'AR',
    EmpMasterId: null,
    ESS_ExpenseRequestMainId: null,
    ESS_ExpenseRequestDetailsId: null,
    ReimburseType: 'Pending',
    FromDate: '' as any,
    ToDate: '' as any,
    FromDateObj: null as any,
    ToDateObj: null as any,
    EmpType: 'All',
    DataType: 'ExpenseReport',
    ReportType: 'R',
    TravelType: 'All',
    EmpCode: '',
    ReimbursementType: 'All'
  }

  constructor(
    private expense: ExpenseService,
    private session: SessionService,
    private modalService: NgbModal,
    protected common: CommonService,
    private toast: ToastService,
    private dateFormat: CustomDateParserFormatter,
    private download: DownloadSampleService,
    private tooltip: TooltipService,
    private router: Router,
  ) {
    this.common.getPageRights();
  }

  exportToExcel() {
    if(this.Filter.ReimbursementType == null || this.Filter.ReimbursementType == ''){
      this.toast.show({ message: 'Please select reimbursement type', type: toastTypeEnum.warning });
      return;
    }
    this.isDisabled = true
    this.Filter.FromDate = this.dateFormat.format(this.Filter.FromDateObj);
    this.Filter.ToDate = this.dateFormat.format(this.Filter.ToDateObj);
    const fromDate = new Date(this.Filter.FromDate);
    const toDate = new Date(this.Filter.ToDate);
    if (toDate < fromDate) {
      this.toast.show({ message: 'To Date must be greater than From Date!', type: toastTypeEnum.warning });
      this.isDisabled = false
      return
    }
    const data = {
      SelectType: this.Filter.DataType,
      FromDate: this.Filter.FromDate,
      ToDate: this.Filter.ToDate,
      Approvalstatus: this.Filter.ReimbursementType,
      TravelType: this.Filter.TravelType,
      EmpMasterID: 0,
      ReportType: this.Filter.ReportType,
      EmpType: this.Filter.EmpType,
	    Empcode: this.Filter.EmpCode,
    }
    this.expense.ESS_ExpenseReport(data).subscribe(
      data => {
        this.ExpenseData = data.Table;
        if (this.ExpenseData.length > 0) {
          this.download.exportToExcel(this.ExpenseData, "Expense Report");
          this.isDisabled = false
        }
        else {
          this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
          this.isDisabled = false
        }
      });
  }
}